import { useTranslation } from 'react-i18next';

import { create, test, enforce } from 'vest';

import { FormUtils } from '@anyx/shared-utils';


import { lineMessageValidation } from '../../../components';
import { LineMessageDialogFormFields } from '../types';

export const useLineMessageDialogFormValidate = () => {
  const { t } = useTranslation('crm');

  const validationSuite = create((data: LineMessageDialogFormFields) => {
    test(
      'title',
      FormUtils.requiredField(t('crm.lineMessageDialogForm.fields.title.label')),
      () => {
        enforce(data.title).isNotBlank();
      }
    );

    lineMessageValidation.validateForm({ messages: data.messages });
  });

  return { validationSuite };
};
